import {
  OPEN_DIALER,
  CLOSE_DIALER,
  TOGGLE_DIALER,
  UPDATE_CALL_STATUS,
  SET_PHONE_NUMBER,
} from "../types/globalDialer.types";

const initialState = {
  isDialerOpen: false,
  phoneNumber: "",
  callStatus: "idle",
  callData: null,
};

const globalDialerReducer = (state = initialState, action) => {
  switch (action.type) {
    case OPEN_DIALER:
      return {
        ...state,
        isDialerOpen: true,
        phoneNumber: action.payload,
        callStatus: "idle",
      };

    case CLOSE_DIALER:
      return {
        ...state,
        isDialerOpen: false,
        // Keep phoneNumber and callStatus for a moment to allow for animation
      };

    case TOGGLE_DIALER:
      return {
        ...state,
        isDialerOpen: !state.isDialerOpen,
      };

    case UPDATE_CALL_STATUS:
      return {
        ...state,
        callStatus: action.payload.status,
        callData: action.payload.data,
      };

    case SET_PHONE_NUMBER:
      return {
        ...state,
        phoneNumber: action.payload,
      };

    default:
      return state;
  }
};

export default globalDialerReducer;
